import { SpaContext } from '../Classes/spacontext';
import { Helper } from '../Common/Helpers/helper';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'Public_old/src/environments/environment';
import { ApplicationService } from '../Services/application.service';
import { devLocalStorage } from 'src/application/dev_local_storage';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
	constructor(
		public _spaContext: SpaContext,
		private helper: Helper,
		private applicationService: ApplicationService,
	) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const defaultOptions = {
			'Content-Type': 'application/json', // Breaks fileupload
			'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
			'Cache-Control': 'no-cache, no-store, must-revalidate',
			Pragma: 'no-cache',
			'X-App-WebVersion': this.applicationService.webVersion,
			'X-App-Lang': `${this._spaContext.languageCode}`,
			'X-XSRF-TOKEN': this.helper.cookie.get('XSRF-TOKEN') || '',
		};

		if (req.body instanceof FormData) {
			// Needed to auto generate corret content type
			delete defaultOptions['Content-Type'];
		}

		// Using this for dev1
		if (!environment.production && devLocalStorage.get('identitySession') !== null) {
			defaultOptions['X-Authorization'] = `ticket ${devLocalStorage.get('identitySession')}`;
			defaultOptions['X-App-SkipXsfrVerification'] = `true`;
		}

		const setHeaders: { [key: string]: string } = {};
		Object.keys(defaultOptions).forEach((key) => {
			if (req.headers.has(key)) return;
			setHeaders[key] = defaultOptions[key];
		});

		const outReq = req.clone({
			setHeaders,
			withCredentials: true,
		});

		return next.handle(outReq).pipe(
			map((event) => {
				if (event instanceof HttpResponse) {
					const response = event as HttpResponse<any>;
					if (!environment.production) {
						if (response.headers.has('X-App-ResourceSession')) {
							localStorage.setItem('identitySession', response.headers.get('X-App-ResourceSession'));
						} else if (response.headers.has('X-App-ClientSession')) {
							localStorage.setItem('identitySession', response.headers.get('X-App-ClientSession'));
						} else if (response.headers.has('X-App-OutsiderSession')) {
							localStorage.setItem('identitySession', response.headers.get('X-App-OutsiderSession'));
						}
					}
				}
				return event;
			}),
		);
	}
}
